import React, { useState } from 'react';

export default function Withdrawal() {
  const [loading, setLoading] = useState(false);
  const [confirmText, setConfirmText] = useState('');

  const handleWithdraw = async () => {
    if (confirmText !== '탈퇴') {
      alert('탈퇴를 원하시면 "탈퇴"를 정확히 입력해 주세요.');
      return;
    }

    if (!window.confirm('정말로 회원 탈퇴를 진행하시겠습니까? 이 작업은 되돌릴 수 없습니다.')) {
      return;
    }

    try {
      setLoading(true);

      const baseUrl = typeof rmVars !== 'undefined' ? rmVars.restApi : '/scholar/wp-json';
      const finalUrl = baseUrl.replace(/\/rm\/v1\/?$/, '') + '/rm/v1/withdrawal';

      const response = await fetch(finalUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-WP-Nonce': typeof rmVars !== 'undefined' ? rmVars.api_nonce : '',
        },
        credentials: 'include',
        body: JSON.stringify({}),
      });

      const data = await response.json();

      if (data?.success) {
        const homeUrl = typeof rmVars !== 'undefined' && rmVars.homeUrl ? rmVars.homeUrl.replace(/\/+$/, '') : '/';
        alert('개인정보가 삭제되었습니다.');
        window.location.href = homeUrl;
      } else {
        throw new Error(data?.message || '탈퇴 처리에 실패했습니다.');
      }
    } catch (error) {
      console.error('Withdrawal error:', error);
      alert(error.message || '탈퇴 처리에 실패했습니다. 다시 시도해 주세요.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="flex justify-between items-center w-full">
        <h3 className="mypage-subpage-title text-[26px] lg:text-[24px] font-black lg:font-bold leading-[130%] lg:leading-[100%]">
          회원 탈퇴
        </h3>
      </div>

      <div className="mypage-card mt-[40px] lg:mt-6 lg:p-[60px] bg-white rounded-[12px]">
        <div className="mb-8">
          <p className="mb-4 text-[18px] font-bold text-[#333]">탈퇴 시 삭제되는 정보</p>
          <ul className="list-disc list-inside space-y-2 text-[15px] text-[#6C7687] leading-[160%]">
            <li>회원 기본 정보 (이름, 이메일 등)</li>
            <li>선호 연구자 목록 (Saved Researcher)</li>
            <li>Researcher ID 연동 정보</li>
            <li>알림 설정</li>
            <li>기타 마이페이지에 저장된 모든 개인 정보</li>
          </ul>
        </div>

        <div className="mb-8 p-4 bg-[#FFF8F0] border border-[#FFE4CC] rounded-[8px]">
          <p className="text-[14px] text-[#B45F06] leading-[160%]">
            ※ 탈퇴 후에는 위 정보를 복구할 수 없습니다. 탈퇴를 진행하시려면 아래 입력란에 <strong>탈퇴</strong>를 입력해 주세요.
          </p>
        </div>

        <div className="mb-8">
          <label htmlFor="confirm-withdrawal" className="block mb-2 text-[14px] font-medium text-[#6C7687]">
            확인 입력
          </label>
          <input
            id="confirm-withdrawal"
            type="text"
            value={confirmText}
            onChange={(e) => setConfirmText(e.target.value)}
            placeholder="탈퇴"
            className="w-full max-w-[300px] h-[44px] px-4 border border-[#E4E8F1] rounded-[8px] text-[14px] placeholder-[#B4BCCC] outline-none"
            disabled={loading}
          />
        </div>

        <button
          type="button"
          onClick={handleWithdraw}
          disabled={loading || confirmText !== '탈퇴'}
          className={`h-[48px] px-8 text-[15px] font-semibold rounded-[12px] ${
            loading || confirmText !== '탈퇴'
              ? 'bg-[#B4BCCC] text-white cursor-not-allowed'
              : 'bg-[#D90000] text-white hover:bg-[#B30000] cursor-pointer'
          }`}
        >
          {loading ? '처리 중...' : '회원 탈퇴하기'}
        </button>
      </div>
    </div>
  );
}
